import { articleHub } from '@/shared/lib/articleHubStyles'
import { ArticleListingCard } from '@/shared/ui/ArticleListingCard'

export type ArticleHubListingItem = {
    id: string
    category: string
    publishedAt: string
    readingMinutes: number
    title: string
    description: string
    imagePath: string
}

type ArticleHubListingProps = {
    articles: ArticleHubListingItem[]
    articlePath: (id: string) => string
    locale: string
    readingMinutesLabel: (count: number) => string
    readArticleLabel: string
    imageObjectClass?: string
}

function formatPublishedAt(isoDate: string, locale: string) {
    return new Intl.DateTimeFormat(locale.startsWith('en') ? 'en-GB' : 'es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }).format(new Date(`${isoDate}T12:00:00`))
}

export function ArticleHubListing({
    articles,
    articlePath,
    locale,
    readingMinutesLabel,
    readArticleLabel,
    imageObjectClass,
}: ArticleHubListingProps) {
    if (articles.length === 0) return null

    const [featured, ...rest] = articles

    const toCardProps = (article: ArticleHubListingItem) => ({
        to: articlePath(article.id),
        category: article.category,
        publishedAt: article.publishedAt,
        formattedPublishedAt: formatPublishedAt(article.publishedAt, locale),
        readingMinutesLabel: readingMinutesLabel(article.readingMinutes),
        title: article.title,
        description: article.description,
        imagePath: article.imagePath,
        imageObjectClass,
    })

    return (
        <ul className={articleHub.grid}>
            {featured ? (
                <li key={featured.id} className={articleHub.leadItem}>
                    <ArticleListingCard
                        {...toCardProps(featured)}
                        variant='lead'
                        readArticleLabel={readArticleLabel}
                        loading='eager'
                        fetchPriority='high'
                    />
                </li>
            ) : null}
            {rest.map(article => (
                <li key={article.id}>
                    <ArticleListingCard {...toCardProps(article)} variant='card' />
                </li>
            ))}
        </ul>
    )
}
